/* Version: 3.5.137 */
'use client';
import canadianTheme from './canadianTheme.js';
import globalTheme from './globalTheme.js';
import johnhancockTheme from './johnhancockTheme.js';

var THEMES = {
  canadianTheme: canadianTheme,
  johnhancockTheme: johnhancockTheme,
  globalTheme: globalTheme
};

export { THEMES, THEMES as default };
